<template>
        <v-layout>
            <v-container fill-height grid-list-xl w--max--800>
                <v-layout row wrap text-xs-center>
                    <v-flex >
                        <h2 class="_title ">Unsubscribe </h2>
                        <p id ="listinginfo">You have been unsubscribed from NannyGranny’s non essential emails. Don’t worry, we’ll still send you important account updates.</p>
                        <div class="flex xs12 ">
                          <v-btn color="primary" class="elevation-0" v-if="showbuttons" @click="unsub_button(user_id)" :id="user_id">
                            Please Confirm
                          </v-btn>
                        </div>
                    </v-flex>                  
                </v-layout>
            </v-container>
        </v-layout>
</template>


<script>

  import moment from 'moment'
  import Vue from 'vue'
  import Store from '@/store/index'
  import { profile as actions } from '@/store/types/action-types'
// global register

  export default {
    name: 'unsubscribe',

    components: {},

    data () {
      return {
        loading: false,
        showbuttons: true,
        queryParams: {},
        user_name : null,
        sub_name : null,
        user_id :null,
      }
    },

    mounted() {
     
      //alert(this.$route.query.id)
      //alert(this.$route.query.token)

      
    },

    computed: {
    
    },
    watch: {
     
    },
    created () {
      var info =this.$store.dispatch('unsubscribe/UNSUBSCRIBE_GET', {token:this.$route.query.token}).then(data => {
               
                this.user_name = data.data.username;
                this.user_id = data.data.id;
                if(data.data.is_active==0){  // 0 means you are unsubscribed
                  this.showbuttons = false;
                  document.getElementById("listinginfo").innerHTML = "You are already unsubscribed."; 
                }
               
              }).catch(() => (alert('There is an error. Please try again')))
     // var info =this.$store.dispatch('unsubscribe/UNSUBSCRIBE_GET', {id: 1001,token:1002})
      
    },
    methods: {
      unsub_button (event){
        this.$store.dispatch('unsubscribe/UNSUBSCRIBE_STORE', {user_id: event,status: 0}).then(data => {
          this.showSnackBar('Thank you ! You will not get notification about this topic now', 'error')
          this.$router.go('')
              }).catch(() => (alert('There is an error. Please try again')))
      }
    }
  }
</script>
<style lang="stylus" scoped>
  #listinginfo
    margin-top 25px;
  ._box
    height 150px !important
  
  .infoprice
    margin 15px 0    

  .cancelsubs
    text-decoration underline
    cursor pointer

  ._with-desc
    margin 25px 0px 0 0 
    font-size 14px
    padding 0 10px

  .textinstruct
    margin: 15px 0
    display inline-block
  #cardexpiry
    margin-left:35px;
  .updatecardbtn
    margin-top 20px
  ._status-box
      color var(--blue)
      border 1px solid
      border-color  var(--grey_3) transparent
      padding 44px 0
      margin-bottom 34px
      > p
          margin-bottom 0
      .svg-icon
          width 16px
          height 16px
          margin-right 6px
  .v-btn--default
      min-width 100%
</style>



// WEBPACK FOOTER //
// src/views/app/unsubscribe/index.vue